<template>
    <div id="appCapsule" class="xpro-sets">
        <div class="pro-avatar-content">
            <div class="avatar-section">
                <div class="app-avatar-img">
                    <img
                        :src="`/avatar/${user.avatar}`"
                        alt="avatar"
                        class="imaged rounded"
                    />
                    <span class="button">
                        <ion-icon name="camera-outline"></ion-icon>
                    </span>
                </div>
                <div class="app-cus-details">
                    <div class="app-cus-name">
                        {{ user.first_name }} {{ user.last_name }}
                    </div>
                    <div class="app-cus-accounts" v-if="user">
                        ({{ user.accounts.length }}) Active Accounts
                    </div>
                </div>
            </div>
        </div>

        <form id="proUpdateForm" method="POST" v-if="user">
            <input type="hidden" name="logged_user" value="665585dacefb1" />
            <input type="hidden" name="btn_action" id="updateAction" />

            <ul class="listview image-listview text inset">
                <li class="listview-xli" @click.prevent="openView(1)">
                    <a
                        href="javascript:void(0)"
                        class="item pro-setup-btn"
                        data-element="app-profile-fields"
                    >
                        <div class="in">
                            <div>Profile Information</div>
                        </div>
                    </a>

                    <div
                        class="app-setup-form app-profile-fields"
                        v-if="current == 1 && open"
                    >
                        <div class="app-setup-form-inner">
                            <div class="form-group">
                                <label class="label">First Name</label>
                                <input
                                    type="text"
                                    name="first_name"
                                    :value="user.first_name"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="form-group">
                                <label class="label">Last Name</label>
                                <input
                                    type="text"
                                    :value="user.last_name"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="form-group">
                                <label class="label">Phone Number</label>
                                <input
                                    type="text"
                                    name="phone"
                                    :value="user.phone"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="form-group">
                                <label class="label">Home Address</label>
                                <input
                                    type="text"
                                    name="home_address"
                                    :value="user.address"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="form-group">
                                <label class="label">City/Region</label>
                                <input
                                    type="text"
                                    name="city"
                                    :value="user.city"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="form-group">
                                <label class="label">State</label>
                                <region-select
                                    class="form-control"
                                    :country="user.country"
                                    :region="user.state"
                                />
                            </div>

                            <div class="form-group">
                                <label class="label">Country</label>
                                <country-select
                                    class="form-control"
                                    :country="user.country"
                                    topCountry="US"
                                />
                            </div>
                        </div>
                    </div>
                </li>

                <li class="listview-xli" @click.prevent="openView(2)">
                    <a
                        href="javascript:void(0)"
                        class="item pro-setup-btn"
                        data-element="app-update-email"
                    >
                        <div class="in">
                            <div>Update E-mail</div>
                        </div>
                    </a>

                    <div
                        class="app-setup-form app-update-email"
                        v-if="current == 2 && open"
                    >
                        <div class="app-setup-form-inner">
                            <div class="form-group">
                                <label class="label">Email Address</label>
                                <input
                                    type="text"
                                    name="new_email"
                                    class="form-control"
                                    v-model="user.email"
                                />
                            </div>

                            <div class="form-group">
                                <button
                                    @click.prevent="updateEmail"
                                    type="button"
                                    value="update_email"
                                    data-btn-action="update_email"
                                    class="btn pro-save-btn vbtn-action"
                                    :disabled="processing"
                                >
                                    {{
                                        processing
                                            ? "Updating..."
                                            : "Update Email"
                                    }}
                                </button>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="listview-xli" @click.prevent="openView(3)">
                    <a
                        href="javascript:void(0)"
                        class="item pro-setup-btn"
                        data-element="app-update-pass"
                    >
                        <div class="in">
                            <div>Update Password</div>
                        </div>
                    </a>

                    <div
                        class="app-setup-form app-update-pass"
                         v-if="current == 3 && open"
                    >
                        <div v-if="errors" class="text-danger">
                            <ul>
                                <li v-for="error in errors">
                                    {{ error.toString() }}
                                </li>
                            </ul>
                        </div>
                        <div class="app-setup-form-inner">
                            <div class="form-group">
                                <label class="label">Old Password</label>
                                <input
                                    type="text"
                                    name="old_pass"
                                    placeholder="Old Password"
                                    class="form-control"
                                    v-model="form.old_password"
                                />
                            </div>

                            <div class="form-group">
                                <label class="label">New Password</label>
                                <input
                                    type="password"
                                    name="new_pass"
                                    placeholder="New Password"
                                    class="form-control"
                                    v-model="form.password"
                                />
                            </div>

                            <div class="form-group">
                                <label class="label">Confirm Password</label>
                                <input
                                    type="password"
                                    name="new_pass"
                                    placeholder="Confirm Password"
                                    class="form-control"
                                    v-model="form.confirm_password"
                                />
                            </div>

                            <div class="form-group">
                                <button
                                    :disabled="processingP"
                                    @click.prevent="updatePassword"
                                    type="submit"
                                    value="update_pass"
                                    data-btn-action="update_pass"
                                    class="btn pro-save-btn vbtn-action"
                                >
                                    {{
                                        processingP
                                            ? "Updating"
                                            : "Update Password"
                                    }}
                                </button>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="listview-xli" @click.prevent="openView(4)">
                    <a
                        href="javascript:void(0)"
                        class="item pro-setup-btn"
                        data-element="app-update-pin"
                    >
                        <div class="in">
                            <div>Update PIN</div>
                        </div>
                    </a>

                    <div
                        class="app-setup-form app-update-pin"
                        v-show="current == 4 && open"
                    >
                        <div class="app-setup-form-inner">
                            <div class="form-group">
                                <label class="label">Old Pin</label>
                                <input
                                    type="text"
                                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                                    placeholder="Old Pin"
                                    class="form-control"
                                    maxlength="4"
                                    v-model="oldPin"
                                />
                            </div>

                            <div class="form-group">
                                <label class="label">New Pin</label>
                                <input
                                    type="text"
                                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                                    placeholder="New Pin"
                                    class="form-control"
                                    maxlength="4"
                                    v-model="newPin"
                                />
                            </div>

                            <div class="form-group">
                                <button
                                    @click.prevent="updatePin"
                                    :disabled="processingPin"
                                    type="submit"
                                    value="update_pin"
                                    data-btn-action="update_pin"
                                    class="btn pro-save-btn vbtn-action"
                                >
                                    {{
                                        processingPin
                                            ? "Updating Pin"
                                            : "Update Pin"
                                    }}
                                </button>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="listview-xli">
                    <div class="item">
                        <div class="in">
                            <div>2 Step Verification</div>
                            <div class="form-check form-switch ms-2">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="verificationSw"
                                    :checked="user.enable_2fa == 1 ? true : false"
                                    @change.prevent="toggle2fa"
                                />
                                <label
                                    class="form-check-label"
                                    for="verificationSw"
                                ></label>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </form>

        <div id="actionLoader"></div>
    </div>
</template>
<script>
import { RepositoryFactory as Repo } from "../../../repository/RepositoryFactory";
const AR = Repo.get("users");
export default {
    data() {
        return {
            errors: [],
            user: {},
            processing: false,
            processingPin: false,
            processingP: false,
            form: new Form({
                password: "",
                confirm_password: "",
                old_password: ""
            }),
            oldPin: "",
            newPin: "",
            open: false,
            current: null
        };
    },
    methods: {
        openView(type){
            this.current = type;
            this.open = true;
        },
        toggle2fa() {
            const user = this.user;
            this.twoFa = !this.twoFa;
            if (user.enable_2fa == 1) {
                let data = {
                    status: 0,
                    user: user.id
                };
                AR.twoFAToggle(data).then(response => {
                    toast.fire({
                        type: "success",
                        title: "Two-Factor Disabled"
                    });
                });
            } else {
                let data = {
                    status: 1,
                    user: user.id
                };
                AR.twoFAToggle(data).then(response => {
                    toast.fire({
                        type: "success",
                        title: "Two-Factor Enabled"
                    });
                });
            }
        },
        updatePin() {
            let data = {
                user: this.user.id,
                old_pin: this.oldPin,
                pin: this.newPin
            };
            this.processingPin = true;
            AR.pinUpdate(data)
                .then(response => {
                    this.processingPin = false;
                    this.oldPin = "";
                    this.newPin = "";
                    toast.fire({
                        type: response.data.status,
                        title: response.data.message
                    });
                })
                .catch(errors => {
                    this.processingPin = false;
                    toast({
                        type: "warning",
                        title: errors.response.data.errors[0].pin
                    });
                });
        },
        updatePassword() {
            let data = {
                user: this.user.id,
                old_password: this.form.old_password,
                password: this.form.password,
                password_confirmation: this.form.confirm_password
            };
            this.processingP = true;
            AR.passwordUpdate(data)
                .then(response => {
                    this.processingP = false;
                    this.form.old_password = "";
                    this.form.password = "";
                    this.form.confirm_password = "";
                    toast.fire({
                        type: response.data.status,
                        title: response.data.message
                    });
                })
                .catch(errors => {
                    this.processingP = false;
                    if (errors.response.status == 422) {
                        this.errors = errors.response.data.errors;
                    }
                    toast({
                        type: "warning",
                        title: "Passwor Update failed"
                    });
                });
        },
        async updateEmail() {
            try {
                this.processing = true;
                await AR.updateProfile(this.user);
                toast.fire({
                    type: "success",
                    title: "Email Update Successful successful"
                });
                this.processing = false;
            } catch (error) {
                this.processing = false;
                toast.fire({
                    type: "error",
                    title: "Failed to upate email"
                });
            }
        }
    },
    created() {
        Fire.$on("Refresh", () => {});
        AR.loggedInUser().then(response => {
            this.user = response.data;
        });
    }
};
</script>
